export default __webpack_public_path__ + "static/media/benefit3.e0b617e1.svg";